import React, { useState } from 'react';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import { WorkshopCard, IconSpinner, IconButtonArrow } from '../../../components';

import css from './SectionUserWorkshops.module.css';

const CARDS_LIMIT = 3;

const SectionUserWorkshops = props => {

  const {
    userWorkshops,
    fetchUserWorkshopsInProgress,
    fetchUserWorkshopsError
  } = props;

  if (!userWorkshops?.length) return null;

  const cardRenderSizes = () => {
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  };

  const [cards, setCards] = useState(userWorkshops?.slice(0, CARDS_LIMIT))

  return (
    <section className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id="ListingPage.educationOfferings" />
      </h2>

      {fetchUserWorkshopsInProgress && (
        <div className={css.loading}>
          <IconSpinner />
        </div>
      )}

      {!fetchUserWorkshopsInProgress && !!userWorkshops?.length &&
        <div className={css.listingsHolder}>
          {cards.map(l => (
            <WorkshopCard
              className={css.listingCard}
              key={l.id.uuid}
              listing={l}
              renderSizes={cardRenderSizes()}
              setActiveListing={() => { }}
              styleTheme='light'
              showLocationAndDate
            />
          ))}
        </div>
      }


      {userWorkshops?.length > CARDS_LIMIT && cards?.length !== userWorkshops?.length && (
        <div className={css.seeAll} onClick={() => setCards(userWorkshops)}>
          <FormattedMessage id="ListingCard.seeAll" />
          <IconButtonArrow />
        </div>
      )}


      {/* {fetchUserWorkshopsError && (
        <div>
          error
        </div>
      )} */}
    </section>
  );
};

export default SectionUserWorkshops;
